import React from 'react';
import { getLocalizedStrings } from '../../profileSettingsLocalizedStrings';
import classes from './profileLanguage.scss';
import SceDropdown from '../../../Common/Dropdown/sceSelectBox';
import SceButton from '../../../Common/CommonComponents/sceButton';
import ProfileLanguagePopup from './languagePopup';

class ProfileLanguageCard extends React.Component{

    constructor(props) {
        super(props);
        this.state = {
            defaultLanguage: '', editBtnClicked: false, availableLanguages: [], selectedLanguage: '', dropDownError: false, isOpenPopup: false, showSaveError: false,
        };
        this.strings = getLocalizedStrings('GeneralSettings');
        this.infoIcon=drupalSettings.path.baseUrl + 'themes/custom/sce_responsive/images/Icon_Information.svg';
    }

    componentWillMount() {
        if(!_.isEmpty(this.props.defaultLanguage)){
            let webLang = app.appUtil.getAppConstants().profileSettingsLanguageConstants[this.props.defaultLanguage];
            this.setState({ defaultLanguage: webLang });
        }
        this.getAvailableLanguages();
        document.addEventListener('mousedown', this.handleClickOutside);
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside);
    }

    getAvailableLanguages() {
        const LanguageConstants = app.appUtil.getAppConstants();
        let languages=[];
        for (const [key, value] of Object.entries(LanguageConstants.profileSettingsLanguageConstants)) {
            let eachLanguage = {};
            eachLanguage.value = key;
            eachLanguage.name = value;
            languages.push(eachLanguage);
        }
        this.setState({availableLanguages:languages});
    }

    editBtnClickHandler = () => {
        window.aUtils.sendAAEvent("button","websiteLanguageEdit");
        this.setState({ editBtnClicked: true });
    }

    langDropDownHandler = (e) => {
        this.setState({selectedLanguage:e.value});}

    onSaveLanguageHandler = () => {
        window.aUtils.sendAAEvent("button","editLanguageSave");
        if(!_.isEmpty(this.state.selectedLanguage)){
            this.setState({dropDownError:false});
            let requestParams = {};
            requestParams.email = this.props.email;
            requestParams.preferredLanguage = this.state.selectedLanguage;
            let reqObj = { reqParams: requestParams };
            app.profileSettingsService.updateProfileV2(reqObj).then((response) => {
                if(response.update === 'success'){
                    let updatedState = { ...this.state };
                    let profileData = app.appService.getUserInfo().profileData;
                    profileData.profile.preferredLanguage = updatedState.selectedLanguage;
                    app.appService.setProfileData(profileData);
                    let route = app.appUtil.getAppRoutes().PROFILE_SETTINGS.PROFILE_SETTINGS_LANDING.substring(1);
                    updatedState.defaultLanguage = app.appUtil.getAppConstants().profileSettingsLanguageConstants[this.state.selectedLanguage];
                    updatedState.editBtnClicked = false;
                    updatedState.showSaveError = false;
                    this.setState({ ...updatedState },()=>{
                        app.appUtil.navigateToFromLogin(route);
                    });
                }else{
                    this.setState({ showSaveError: true });
                }
            },(error) => {
                this.setState({ showSaveError: true });
            });
        }else this.setState({dropDownError:true});
    }

    cancelBtnHandler = () => {
        this.setState({ editBtnClicked: false, showSaveError: false });
    }
    toolTipKeyPress= (e) =>{
        if(e.key === "Enter"){
            this.toolTipClickHandler();}
    }
    toolTipClickHandler = () => {
        this.setState({infoPopUp:!this.state.infoPopUp});
    }
    onHoverOverEvent =(e)=>{
        if(e.type === "mouseenter"){
          this.setState({infoPopUp:true});
        }
      }
      onHoverOutEvent = (e) =>{
        this.setState({infoPopUp:false});
      }

    getViewToShow = () => {
        if(this.state.editBtnClicked){
            let warningIcon = drupalSettings.path.baseUrl + 'themes/custom/sce_responsive/images/Icon_Warning.svg';
            let errorView = this.state.showSaveError ? 
                            <div className={classes.langErrSec}>
                                <img className={classes.warningIcon} src={warningIcon} alt="Warning Icon" />
                                <p className={classes.warningMsg}>{this.strings.saveError}</p>
                            </div> : null;
            return(
                <div>
                    <div className={classes.languageLabel}>
                        <span>{this.strings.editLanguageLabel}</span>
                        <span className={classes.infoIconPadding}><button className={classes.iconAlign}> <img  src={this.infoIcon} onClick={this.togglePopup} alt="Info Icon" /></button></span>
                    </div>
                    <div className={classes.langDropDown}>
                        <SceDropdown 
                            id='WebsiteLanguage'
                            defaultText={this.state.defaultLanguage}
                            displayDefaultText={false}
                            selectBoxData={this.state.availableLanguages}
                            errorMessage={this.strings.langDropDownErrorMsg}
                            handleClick={this.langDropDownHandler}
                            isError={this.state.dropDownError}
                        />
                    </div>
                    <div className={'row ' + classes.langButtons}>
                        <div className={'col-md-6 ' + classes.langSaveBtn}>
                            <SceButton
                                id='Save'
                                buttonType='default'
                                value={this.strings.save}
                                onClick={this.onSaveLanguageHandler}
                            />
                        </div>
                        <div className={'col-md-6 ' + classes.langCancelBtn}>
                            <SceButton
                                id='Cancel'
                                buttonType='default'
                                onClick={this.cancelBtnHandler}
                                value={this.strings.cancel}
                            />
                        </div>
                    </div>
                    {errorView}
                </div>
            );
        }else{
            return(
                <div>
                    <div className={classes.languageLabel}>
                        <span>{this.strings.languageLabel}</span>
                        <span className={classes.infoIconPadding}><button tabIndex={-1} className={classes.iconAlign}> <img src={this.infoIcon} alt="Info Icon" tabIndex={0} onMouseEnter={this.onHoverOverEvent} onKeyPress={(e)=> this.toolTipKeyPress(e)} /> </button></span>
                    </div>
                    <div onMouseEnter={this.onHoverOutEvent} className={classes.editButtonPadding}><button className={classes.editButton} id="websiteLanguage" onClick={this.editBtnClickHandler} >{this.strings.editBtn}</button></div>
                    <div onMouseEnter={this.onHoverOutEvent} className={classes.languageContent}>{this.state.defaultLanguage}</div>
                </div>
            );
        }
    }

    render(){
        let view = this.getViewToShow();
        let popUp = this.state.infoPopUp ? <div><ProfileLanguagePopup editView={this.state.editBtnClicked} /></div> : null;
        return(
            <div onMouseLeave={this.onHoverOutEvent}>
                {popUp}
                <div className={classes.Card}>
                    {view}
                </div>
            </div>
        );
    }
}

export default ProfileLanguageCard;
